import { useParams } from 'react-router';
import { NotFound } from '~/components/common/NotFound';
import VftViewer from '~/components/virtualFieldTrip/vft-viewer';

export default function VftViewerRoute() {
  const params = useParams<{ vftId: string }>();
  if (!params.vftId) {
    console.log('no vftid found');
    return <NotFound />;
  }

  return (
   <VftViewer id={params.vftId} />
  );
}
